import './ccf-upload-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfUploadIconProps extends SvgIconProps {}
/**
 * component used to display upload icon in text editor
 * @param props - CcfUploadIconProps
 * @example - <CcfUploadIcon />
 * @returns SVG of upload icon in text editor
 */
export function CcfUploadIcon(props: CcfUploadIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="paper_clip_icon" data-name="Paper Clip" transform="translate(3.702 3.702)">
            <path d="M15.246,10.49l-5.033,5.041a3.461,3.461,0,0,1-4.886-4.886L11.842,4.13a2.093,2.093,0,0,1,2.883,0,2.052,2.052,0,0,1,0,2.883L9.105,12.624a.622.622,0,0,1-.912-.847l4.178-4.17a.818.818,0,1,0-1.156-1.156L7.037,10.637a2.231,2.231,0,0,0,0,3.168,2.3,2.3,0,0,0,3.168,0l5.611-5.619a3.665,3.665,0,0,0-5.18-5.18L4.121,9.521a5.09,5.09,0,0,0,7.24,7.142L16.4,11.63a.818.818,0,1,0-1.156-1.156Z" transform="translate(-2.809 -2.022)"/>
        </g>
    </SvgIcon>
  );
}

export default CcfUploadIcon;
